<form [formGroup]="form" [attr.autocomplete]="'off'">
  <div class="form-row">
    <mat-form-field [appearance]="appearance">
      <mat-label>Indtast fabrikat</mat-label>

      <mat-chip-grid #chipList aria-label="Fabrikat selection">
        @if (selectedFabrikat) {
          <mat-chip-row>
            {{ selectedFabrikat }}
          </mat-chip-row>
        }

        <input
          #fabrikatInput
          [formControl]="fabrikatCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addFabrikat($event)"
          />
        </mat-chip-grid>

        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          @for (fabrikat of filteredFabrikater | async; track fabrikat) {
            <mat-option
              [disabled]="fabrikat.fabrikatstatus === 'No'"
              [value]="fabrikat.name"
              >
              {{ fabrikat.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </form>
